import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Avatar } from '@ui-kitten/components';
import { StyleSheet, Image, View, Dimensions } from 'react-native';
import axios from 'axios'

import moment from 'jalali-moment'
const month = ['فروردین','اردیبهشت','خرداد','تیر','مرداد','شهریور','مهر','آبان','آذر','دی','بهمن','اسفند'];
const width = Dimensions.get('window').width-30
export const TopBar = ({ navigation }) => {
  const [date, setDate] = useState(moment().locale('fa').format('DD') + ' ' + month[Number(moment().locale('fa').format('MM'))-1] +' '+ moment().locale('fa').format('YYYY'))
  const [time, setTime] = useState(moment().locale('fa').format('HH:mm'))
  const [dayAPI, setDayAPI] = useState()
  const getTime = async() => {
    const response = await axios.get('https://api.keybit.ir/time/')
    console.log(response.data.date.weekday.name);
    if(response.data && response.data.date) setDayAPI(response.data.date)
  }
  React.useEffect(()=>{
    getTime()
  }, [])
  var timer;
    clearInterval(timer);
    timer = setInterval(()=>{
      setTime(moment().locale('fa').format('HH:mm'));
      let timeString = moment().locale('fa').format('DD') + ' ' + month[Number(moment().locale('fa').format('MM'))-1] +' '+ moment().locale('fa').format('YYYY');
      setDate(timeString)
    },5000)
  return (
        <View style={styles.topContainer}>
          <SafeAreaView style={{alignItems:'center'}}>
          <View style={styles.container}>
          <Image
            style={{width:4.93 * 30, height: 32}}
            source={require('../../../assets/logo-light.png')}

          />
          <Text category='h6' style={styles.text}>فناوران نوین پارسیان تصویر فدک</Text>
          <Text category='c2' appearance='hint' style={styles.text}>خدمات پس از فروش</Text>

          <View style={{flexDirection:'row' , justifyContent:'space-between',alignItems:'flex-end', width}}>
          <View style={{flex:4}}>
          <Text category='p1' style={styles.text}>{dayAPI ? dayAPI.weekday.name : ''} {date}</Text>
          { dayAPI && dayAPI.day.events.holy && dayAPI.day.events.holy.text &&
          <Text category='c1' appearance='hint' styles={{width: width/3}}>{dayAPI.day.events.holy.text}</Text>
        }
          </View>
          <Text category='p1' style={{...styles.text, flex: 1}}>{time}</Text>

          </View>
          </View>

          </SafeAreaView>
        </View>
  );
};

const styles = StyleSheet.create({
  container:{
    justifyContent:'flex-start',
    alignItems:'center',

  },
  topContainer: {
    flexDirection:'row',
    justifyContent: 'center',
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    paddingVertical: 5,
    paddingHorizontal:10,
    backgroundColor:'#134A93',
  },
  layout: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color:'#f5f5f5',
    marginTop:8
  }
});
